import { render, staticRenderFns } from "./DeliveryFollowersDialog.vue?vue&type=template&id=78bff95e"
import script from "./DeliveryFollowersDialog.vue?vue&type=script&lang=js"
export * from "./DeliveryFollowersDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports